/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicPolicyRefresh extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicPolicyRefresh");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicPolicyRefresh.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicPolicyRefresh>): BackgroundJobPayloadForPeriodicPolicyRefresh {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicPolicyRefresh(), model);
        BackgroundJobPayloadForPeriodicPolicyRefresh.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicPolicyRefresh>): BackgroundJobPayloadForPeriodicPolicyRefresh {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicPolicyRefresh.newInstance(<BackgroundJobPayloadForPeriodicPolicyRefresh> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicPolicyRefresh) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicPolicyRefresh.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicPolicyRefresh): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicPolicyRefresh.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
